import { render, staticRenderFns } from "./VideoPlayerSeries.vue?vue&type=template&id=20d579ce&scoped=true&"
import script from "./VideoPlayerSeries.vue?vue&type=script&lang=js&"
export * from "./VideoPlayerSeries.vue?vue&type=script&lang=js&"
import style0 from "./VideoPlayerSeries.vue?vue&type=style&index=0&id=20d579ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d579ce",
  null
  
)

export default component.exports